<script setup>
import { computed } from "vue";
import { useCustomizerStore } from "@/stores/customizer";

const customizer = useCustomizerStore();

//const dark = ref(false);
const dark = computed(() => {
  if (
    customizer.actTheme === "DARK_ORANGE_THEME"
  ) {
    return true;
  } else {
    return false;
  }
});
</script>
<template>
    <div class="logo py-2">
        <lcFullLogoLight v-if="dark" v-bind="$attrs" />
        <lcFullLogoDark v-else v-bind="$attrs" />
    </div>
    <div class="mini-icon pa-0">
        <lcFullLogoLightMini v-if="dark" v-bind="$attrs" />
        <lcFullLogoDarkMini v-else v-bind="$attrs" />
    </div>
</template>
